import {usePageStore} from '@/store/page.store.js'
import {useConfig} from '@/composables/use-config.js'
import {computed} from 'vue'

/**
 * Page composable
 */
export function usePage() {

  //Composables
  const store = usePageStore()
  const {app} = useConfig()

  //Extract store properties and methods
  const {setTitle} = store

  //Page title (with app name)
  const title = computed(() => {
    const parts = []
    if (store.title) {
      parts.push(store.title)
    }
    if (app.name) {
      parts.push(app.name)
    }
    return parts.join(' | ')
  })

  //Expose interface
  return {
    title,
    setTitle,
  }
}
